/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import * as R from 'ramda';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { withTitle } from '../../../reactutils/withTitle';
import { loadPlaylistStatistics } from './actions';
import { playlistStatisticSelector } from './selectors';

const PlaylistStatistics: FC<{}> = () => {
    const statistic = useSelector(playlistStatisticSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadPlaylistStatistics());
    }, [dispatch]);

    if (!statistic) {
        return <div>Loading ...</div>;
    } else {
        return (
            <div className="d-flex justify-content-center">
                <Container className="justify-content-center">
                    <Row >
                        <Col className="bg-info text-white p-2 bt-1">
                            Songs
                        </Col>
                    </Row>
                    <Row>
                        <Col className="p-2">Anzahl insgesamt</Col>
                        <Col className="text-end p-2">{statistic.totalNumberOfSongs}</Col>
                    </Row>
                    <Row>
                        <Col className="p-2">Songs auf Alben</Col>
                        <Col className="text-end p-2">{statistic.totalNumberOfSongsWithAlbum}</Col>
                    </Row>

                    <Row>
                        <Col className="bg-info text-white p-2 bt-1">
                            Alben
                        </Col>
                    </Row>
                    <Row>
                        <Col className="p-2">Anzahl insgesamt</Col>
                        <Col className="text-end p-2">{statistic.totalNumberOfAlbums}</Col>
                    </Row>
                    <Row>
                        <Col className="p-2">Alben mit Cover</Col>
                        <Col className="text-end p-2">{statistic.totalNumberOfAlbumWithCover}</Col>
                    </Row>
                    <Row>
                        <Col className="p-2">vollständige Alben</Col>
                        <Col className="text-end p-2">{statistic.totalNumberOfAlbumsComplete}</Col>
                    </Row>

                    <Row>
                        <Col className="bg-info text-white p-2 bt-1">
                            Lieblingsmusik
                        </Col>
                    </Row>
                    <Row>
                        <Col className="p-2">User mit Lieblingsmusik</Col>
                        <Col className="text-end p-2">{statistic.totalNumberOfDistinctUsersInUserSongs}</Col>
                    </Row>
                    <Row>
                        <Col className="p-2">Anzahl Lieblingsmusik</Col>
                        <Col className="text-end p-2">{statistic.totalNumberOfUserSongs}</Col>
                    </Row>
                </Container>
            </div>
        );
    }
};

export default R.compose(withTitle('Playlist Statistics'))(PlaylistStatistics);
